import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "./apiClient";

export function useAgenda(userId, setCustomers, onLeadSaved) {
  const [leads, setLeads] = useState([]);
  const [appointments, setAppointments] = useState([]);
  useEffect(() => {
    if (!userId) return;
    axios.get(`${API}/leads`).then(({ data }) => setLeads(data)).catch(() => {});
    axios.get(`${API}/appointments`).then(({ data }) => setAppointments(data)).catch(() => {});
  }, [userId]);

  const saveLead = async (form) => {
    try {
      const { data } = form.id ? await axios.put(`${API}/leads/${form.id}`, form) : await axios.post(`${API}/leads`, { ...form, source: "Manuel" });
      setLeads((x) => (form.id ? x.map((l) => (l.id === data.id ? data : l)) : [data, ...x]));
      if (form.id) setAppointments((x) => x.map((a) => (a.customerId === data.id ? { ...a, customerName: data.name, phone: data.phone } : a)));
      onLeadSaved();
    } catch (e) { window.alert(e?.response?.data?.detail || "Aday kaydedilemedi."); }
  };
  const convertLead = async (lead) => {
    if (!window.confirm(`${lead.name} müşteriye dönüştürülsün mü? Müşteriler sayfasına aktarılacak.`)) return;
    try {
      const { data } = await axios.post(`${API}/leads/${lead.id}/convert`);
      setCustomers((x) => [data, ...x]);
      setLeads((x) => x.filter((l) => l.id !== lead.id));
      setAppointments((x) => x.map((a) => (a.customerId === lead.id ? { ...a, customerKind: "customer" } : a)));
    } catch (e) { window.alert(e?.response?.data?.detail || "Dönüştürülemedi."); }
  };
  const deleteLead = async (lead) => {
    if (!window.confirm(`${lead.name} adayı ve randevuları silinsin mi?`)) return;
    try { await axios.delete(`${API}/leads/${lead.id}`); setLeads((x) => x.filter((l) => l.id !== lead.id)); setAppointments((x) => x.filter((a) => a.customerId !== lead.id)); } catch (e) { window.alert(e?.response?.data?.detail || "Silinemedi."); }
  };
  const upsertAppt = (a) => setAppointments((x) => (x.some((y) => y.id === a.id) ? x.map((y) => (y.id === a.id ? a : y)) : [...x, a]));
  return { leads, setLeads, appointments, setAppointments, saveLead, convertLead, deleteLead, upsertAppt };
}
